import React from 'react';
import TitledSidebar from '@fingo/lib/components/layout/TitledSidebar';
import ProfileSideCompanies from '../views/App/profile/ProfileSideCompanies';
import ProfileSideSettings from '../views/App/profile/ProfileSideSettings';
import ProfileSideTerms from '../views/App/profile/ProfileSideTerms';
import ProfileSideRegister from '../views/App/profile/ProfileSideRegister';
import MyCompanies from '../views/App/profile/myCompanies/MyCompanies';
import MyInfo from '../views/App/profile/info/MyInfo';
import MySettings from '../views/App/profile/settings/MySettings';
import MyTerms from '../views/App/profile/terms/MyTerms';
import Credentials from '../views/App/profile/credentials/Credentials';

const profileSubRoutes = () => [
  {
    id: 'profile-side-info',
    label: 'Mi información',
    path: 'info',
    component: <MyInfo />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
  {
    id: 'profile-side-credentials',
    label: 'Mis documentos',
    path: 'credentials',
    component: <Credentials />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
  {
    id: 'profile-side-companies',
    label: 'Mis empresas',
    path: 'empresas',
    component: <ProfileSideCompanies />,
    disabled: false,
    show: false,
    showInSidebar: true,
  },
  {
    id: 'profile-side-settings',
    label: 'Configuraciones',
    path: 'settings',
    component: <ProfileSideSettings />,
    disabled: false,
    show: false,
    showInSidebar: true,
  },
  {
    id: 'profile-side-terms',
    label: 'TyC',
    path: 'terms',
    component: <ProfileSideTerms />,
    disabled: false,
    show: false,
    showInSidebar: true,
  },
  {
    id: 'profile-side-register',
    label: 'Terminar registro',
    path: 'register',
    component: <ProfileSideRegister />,
    disabled: false,
    show: false,
    showInSidebar: true,
  },
];

export const myCompaniesTabs = () => [
  {
    id: 'my-companies',
    label: 'Mis empresas',
    path: 'my-companies',
    component: <MyCompanies />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

export const settingsTabs = () => [
  {
    id: 'my-settings',
    label: 'Configuraciones',
    path: 'my-settings',
    component: <MySettings />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

export const termsTabs = () => [
  {
    id: 'my-terms',
    label: 'Términos',
    path: 'my-terms',
    component: <MyTerms />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

export const credentialsTabs = () => [
  {
    id: 'my-credentials',
    label: 'Credenciales',
    path: 'credentials',
    component: <Credentials />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

const profileRoutes = () => [
  {
    id: 'profile',
    label: 'Perfil',
    path: '/app/profile',
    component: <TitledSidebar
      title="Perfil"
      sidebarProps={{
        options: profileSubRoutes(), useHideDrawer: false }}
      useBackLink
      backLabel="VOLVER"
      backPath="/app"
    />,
    disabled: false,
    show: true,
    showInNavbar: false,
    subRoutes: profileSubRoutes(),
  },
];

export default profileRoutes;
